module.exports = __webpack_public_path__ + "static/media/fonts-1-mobile.088bd6e8.svg";